import React, { useState } from "react";
import { TextField, Box, Grid } from "@mui/material";


const Input = ({
  label,
  icon: Icon,
  grid,
  placeHolder,
  value,
  onChange,
  onlyNumber,
  alphanumeric,
  ...props
}) => {
  const [error, setError] = useState("");

  const validateInput = (inputValue) => {
    if (onlyNumber && !/^\d*$/.test(inputValue)) {
      setError("Only numbers are allowed");
      return false;
    }
    if (alphanumeric && !/^[a-zA-Z0-9]*$/.test(inputValue)) {
      setError("Only alphanumeric characters are allowed");
      return false;
    }
    setError(""); // Clear error if validation passes
    return true;
  };

  const handleChange = (event) => {
    const inputValue = event.target.value;
    if (validateInput(inputValue)) {
      if (onChange) onChange(event); // Pass the entire event object
    }
  };

  return (
    <Grid item xs={grid ? Number(grid) : 12}>
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          fontSize: "14px", // Adjust as needed
        }}
      >
        {Icon && <Icon />}
        {label}
      </Box>

      <TextField
        value={value}
        fullWidth
        placeholder={placeHolder}
        onChange={handleChange}
        name={label} // Dynamic name attribute
        error={!!error}
        helperText={error}
        required
        {...props} // Spread remaining props for flexibility
      />
    </Grid>
  );
};

export default Input;
